class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		
		this.submitted = false
	  	this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
	  	this.onSorterFilterClick = this.onSorterFilterClick.bind(this);
  
		this.debouncedOnSubmit = debounce((event) => {
			if (event.target.name === 'sort_by') {
				const drawer = event.target.closest('menu-drawer');
				if (drawer) {
					const closeButtons = drawer.querySelectorAll('.mobile-facets__close');
					closeButtons.forEach(button => {
						button.click();
					});
				}
			}
			this.onSubmitHandler(event);
		}, 500);
		
	const facetForm = this.querySelector('form');
	facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

	const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
	if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
		
	const self = this;

	const sortByTrigger = document.getElementById('sortByTrigger');
	sortByTrigger.addEventListener('change', function() {
		const sortByMirror = document.getElementById('SortBy');
		const selectedValue = sortByTrigger.value;
		sortByMirror.value = selectedValue;

		// Optionally trigger a change event on the mirror select if needed
		const event = new Event('change');
		sortByMirror.dispatchEvent(event);

		self.onSubmitHandler(event);
	});
	  
	}
  
	static setListeners() {
	  const onHistoryChange = (event) => {
		const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
		if (searchParams === FacetFiltersForm.searchParamsPrev) return;
		FacetFiltersForm.renderPage(searchParams, null, false);
	  }
	  window.addEventListener('popstate', onHistoryChange);
	}
  
	static toggleActiveFacets(disable = true) {
	  document.querySelectorAll('.js-facet-remove').forEach((element) => {
		element.classList.toggle('disabled', disable);
	  });
	}
  
	static renderPage(searchParams, event, updateURLHash = true) {
	  FacetFiltersForm.searchParamsPrev = searchParams;
	  const sections = FacetFiltersForm.getSections();
	  const countContainer = document.getElementById('ProductCount');
	  const countContainerDesktop = document.getElementById('ProductCountDesktop');
	  document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
	  if (countContainer){
		countContainer.classList.add('loading');
	  }
	  if (countContainerDesktop){
		countContainerDesktop.classList.add('loading');
	  }
  
	  sections.forEach((section) => {
		const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
		const filterDataUrl = element => element.url === url;
  
		FacetFiltersForm.filterData.some(filterDataUrl) ?
		  FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
		  FacetFiltersForm.renderSectionFromFetch(url, event);
	  });
  
	  if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}
  
	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then(response => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
				this.submitted = false;
			}).then(() => {
				const div = document.getElementById('FacetsWrapperDesktop')
				window.scrollTo({
					top: div.offsetTop,
					behavior: "smooth"
				});

                const customEvent = new Event('lazyloadImage');
        		document.dispatchEvent(customEvent);
			});
	}
  
	static renderSectionFromCache(filterDataUrl, event) {
	  const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
	  FacetFiltersForm.renderFilters(html, event);
	  FacetFiltersForm.renderProductGridContainer(html);
	  FacetFiltersForm.renderProductCount(html);
	}
  
	static renderProductGridContainer(html) {
	  document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
	}
  
	static renderProductCount(html) {
	  const count = new DOMParser().parseFromString(html, 'text/html').getElementById('totalResults').innerHTML;
	 
	  const container = document.getElementById('ProductCount');
	  const containerDesktop = document.getElementById('ProductCountDesktop');
	  container.innerHTML = count;
	  container.classList.remove('loading');
	  if (containerDesktop) {
		containerDesktop.innerHTML = count;
		containerDesktop.classList.remove('loading');
	  }
	}
  
	static renderFilters(html, event) {
	  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  
	  const facetDetailsElements =
		parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
	  const matchesIndex = (element) => {
		const jsFilter = event ? event.target.closest('.js-filter') : undefined;
		return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
	  }
	  const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
	  const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
  
		facetsToRender.forEach((element) => {
		  if(document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`))
			document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
	  });
  
	  FacetFiltersForm.renderActiveFacets(parsedHTML);
	  FacetFiltersForm.renderAdditionalElements(parsedHTML);
  
	  if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
	}
  
	static renderActiveFacets(html) {
	  const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
  
	  activeFacetElementSelectors.forEach((selector) => {
		const activeFacetsElement = html.querySelector(selector);
		if (!activeFacetsElement) return;
		document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
	  })
  
	  FacetFiltersForm.toggleActiveFacets(false);
	}
  
	static renderAdditionalElements(html) {
	  const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
  
	  mobileElementSelectors.forEach((selector) => {
		if (!html.querySelector(selector)) return;
		document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
	  });
  
	  document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
	}
  
	static renderCounts(source, target) {
	  const targetElement = target.querySelector('.facets__selected');
	  const sourceElement = source.querySelector('.facets__selected');
  
	  const targetElementAccessibility = target.querySelector('.facets__summary');
	  const sourceElementAccessibility = source.querySelector('.facets__summary');
  
	  if (sourceElement && targetElement) {
		target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
	  }
  
	  if (targetElementAccessibility && sourceElementAccessibility) {
		target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
	  }
	}
  
	static updateURLHash(searchParams) {
		// Parse the searchParams string into a URLSearchParams object
		const params = new URLSearchParams(searchParams);

		// Delete the 'page' parameter if it exists
		params.delete('page');
		
		history.pushState({ searchParams: params.toString() }, '', `${window.location.pathname}${params.toString() && '?'.concat(params.toString())}`);
		
	}
  
	static getSections() {
	  return [
		{
		  section: document.getElementById('product-grid').dataset.id,
		}
	  ]
	}
  
	createSearchParams(form) {
	  const formData = new FormData(form);
	  return new URLSearchParams(formData).toString();
	}
  
	onSubmitForm(searchParams, event) {
	  FacetFiltersForm.renderPage(searchParams, event);
	}
  
	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll('facet-filters-form form');
		if (event.srcElement.className == 'mobile-facets__checkbox') {
			  const forms = [];
			  const searchParams = this.createSearchParams(event.target.closest('form'))
			  forms.push(searchParams);
			  if (document.querySelector('.sorting-form')) {
				  const otherParams = this.createSearchParams(document.querySelector('.sorting-form'))
				  forms.push(otherParams);
			  }
			  this.onSubmitForm(forms.join('&'), event)
		  } else {
			  const forms = [];
			  const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
		  
			  sortFilterForms.forEach((form) => {
				  if (!isMobile) {
					  if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
						  const noJsElements = document.querySelectorAll('.no-js-list');
						  noJsElements.forEach((el) => el.remove());
						  forms.push(this.createSearchParams(form));
					  }
				  } else if (form.id === 'FacetFiltersFormMobile') {
					  forms.push(this.createSearchParams(form));
				  }
			  });
  
			  this.onSubmitForm(forms.join('&'), event)
		  }
	}
   
	onActiveFilterClick(event) {
	  event.preventDefault();
	  FacetFiltersForm.toggleActiveFacets();
	  const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
	  FacetFiltersForm.renderPage(url);
	}
	  
	onSorterFilterClick(event) {
		// console.log('sort')
	  	event.preventDefault();
		document.querySelectorAll('[name="sort_by"]').forEach(sort => {
			sort.value = event.target.getAttribute('data-value');
		});

		this.onSubmitHandler(event);
	}
  }
  
  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();
  
  class PriceRange extends HTMLElement {
	constructor() {
	  super();
	  this.querySelectorAll('input')
		.forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
	  this.setMinAndMaxValues();
	}
  
	onRangeChange(event) {
	  this.adjustToValidValues(event.currentTarget);
	  this.setMinAndMaxValues();
	}
  
	setMinAndMaxValues() {
	  const inputs = this.querySelectorAll('input');
	  const minInput = inputs[0];
	  const maxInput = inputs[1];
	  if (maxInput.value) minInput.setAttribute('max', maxInput.value);
	  if (minInput.value) maxInput.setAttribute('min', minInput.value);
	  if (minInput.value === '') maxInput.setAttribute('min', 0);
	  if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
	}
  
	adjustToValidValues(input) {
	  const value = Number(input.value);
	  const min = Number(input.getAttribute('min'));
	  const max = Number(input.getAttribute('max'));
  
	  if (value < min) input.value = min;
	  if (value > max) input.value = max;
	}
  }
  
  customElements.define('price-range', PriceRange);
  
  class FacetRemove extends HTMLElement {
	constructor() {
	  super();
	  const facetLink = this.querySelector('a');
	  facetLink.setAttribute('role', 'button');
	  facetLink.addEventListener('click', this.closeFilter.bind(this));
	  facetLink.addEventListener('keyup', (event) => {
		event.preventDefault();
		if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
	  });
	}
  
	closeFilter(event) {
	  event.preventDefault();
	  const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
	  form.onActiveFilterClick(event);
	}
  }
  
  customElements.define('facet-remove', FacetRemove);
  

 
function _lazyLoaded() {
	if ('loading' in HTMLImageElement.prototype) {
		const images = document.querySelectorAll('.lazyImage');
		images.forEach(img => {
			if (img?.dataset?.src && !img.classList.contains('lazyloaded')) {
				img.removeAttribute('loading')
				img.classList.add('lazyloaded')
				img.src = img.dataset.src;
			}

			if (!img?.dataset?.src && !img.classList.contains('lazyloaded')) {
				img.removeAttribute('loading')
				img.classList.add('lazyloaded')
			}
		});
	} else {
		// Dynamically import the LazySizes library
		const script = document.createElement('script');
		script.src =
		'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
		document.body.appendChild(script);
	}
}

_lazyLoaded();

document.addEventListener('lazyloadImage', _lazyLoaded);
